// extracted by mini-css-extract-plugin
export default {"container":"p7FgJ7bt5R_ri76dwGL6"};